<!-- eslint-disable vue/require-explicit-emits -->
<template>
  <iButton
    v-if="shouldRenderButton"
    :key="defaultTemplateName"
    :size="myButtonSize"
    :variant="getOptionValue(ButtonType)"
    :width="myWidth"
    :height="myHeight"
    :style-overrides="buttonStyleOverrides"
    :text-alignment="getOptionValue(TextAlignment)"
    :icon-left="displayLeftIcon ? getOptionValue(Icon) : ''"
    :icon-right="displayRightIcon ? getOptionValue(Icon) : ''"
    :icon-top="displayTopIcon ? getOptionValue(Icon) : ''"
    :icon-bottom="displayBottomIcon ? getOptionValue(Icon) : ''"
    :icon-left-size="displayLeftIcon ? myIconSize : 'standard'"
    :icon-right-size="displayRightIcon ? myIconSize : 'standard'"
    :icon-top-size="displayTopIcon ? myIconSize : 'standard'"
    :icon-bottom-size="displayBottomIcon ? myIconSize : 'standard'"
    :icon-color="fontColor"
    @click="handleButtonClick"
  >
    <template #[defaultTemplateName]>
      <!--
        `textOnlyAttributes` returns an object with `textStyleOverrides`
        (the iRichText prop name used by the Builder variant). iText has
        the same data under `styleOverrides` instead. Bind that one
        explicitly so the font-color / font-size / etc. overrides
        actually reach iText — otherwise iText falls back to its
        styleGuide defaults and the user-set FontColor is silently
        replaced with the theme's standard font colour (e.g. "accent"
        rendered as off-white instead of orange). `v-bind` still passes
        the other text-only attributes (textCase, textAlign, …).
      -->
      <iText
        v-bind="textOnlyAttributes"
        :style-overrides="textOnlyAttributes.textStyleOverrides"
      >
        {{ renderedText }}
      </iText>
    </template>
  </iButton>
</template>

<script>
// Lightweight canvas render for unselected `ButtonElement` instances.
// Mirrors `BaseButtonElement.vue`'s iButton branch but renders the label
// via plain iText instead of iRichText, so unselected buttons skip the
// rich-text editor mount, the inline-edit click logic, and the text-option
// → initialValue watcher in `text-without-branding-element-mixin.js`.
//
// Mounted by `DynamicComponentBuilderElement` whenever the element is not
// selected for editing OR is rendered on a non-default breakpoint frame.
// Selection re-routes mounting back to `ButtonElement.vue`.
import ButtonType from "%/dynamic-component-editor/options/button-type";
import Icon from "%/dynamic-component-editor/options/icon";
import ButtonIconSize from "%/dynamic-component-editor/options/button-icon-size";
import TextAlignment from "%/dynamic-component-editor/options/text-alignment";
import {
  ButtonElementRenderMixin,
} from "%/dynamic-component-editor/standard-elements/button-element/button-element-render-mixin";

export default {
  name: "ButtonElementProduction",
  // Production twin: exempt from the palette's elementPanelSettings gate.
  production: true,
  mixins: [ButtonElementRenderMixin],
  data() {
    return {
      ButtonType,
      Icon,
      ButtonIconSize,
      TextAlignment,
    };
  },
};
</script>
